import type { CSSProperties } from 'react';

type HostedVideoPosterProps = {
  posterUrl: string | null;
  borderRadius?: CSSProperties['borderRadius'];
};

// Without a playback resolver, such as in the Swarm page preview, a hosted video shows as its poster.
// Inline styles, not Tailwind: Orchid's theme does not generate aspect-ratio utilities.
export const HostedVideoPoster = ({ posterUrl, borderRadius }: HostedVideoPosterProps) => (
  <div
    data-testid="hosted-video-poster"
    style={{
      position: 'relative',
      width: '100%',
      aspectRatio: '16 / 9',
      borderRadius,
      overflow: 'hidden',
      backgroundColor: '#000',
    }}
  >
    {posterUrl && (
      <img
        src={posterUrl}
        alt=""
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
      />
    )}
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      aria-hidden="true"
      style={{ position: 'absolute', inset: 0, margin: 'auto' }}
    >
      <circle cx="28" cy="28" r="28" fill="rgba(0, 0, 0, 0.6)" />
      <path d="M23 19.5v17l14-8.5-14-8.5Z" fill="#fff" />
    </svg>
  </div>
);
